import { useContext } from 'react';

import { type ToastApi, ToastContext } from './toast-context';

/** Short confirmations after an action: `toast.success('Member saved')`. */
export function useToast(): ToastApi {
  const api = useContext(ToastContext);
  if (!api) throw new Error('useToast must be used inside <ToastProvider>');
  return api;
}
